import PropTypes from 'prop-types'

import Modal, { ModalBody, ModalHeader } from '../../../common/Modal'
import UserEditCreateForm from '../form'

const CreateUpdateUser = (props) => {
  return (
    <Modal
      onClose={() => {
        props.setShowModal(false)
      }}
      show={props.showModal}
    >
      <ModalHeader className={'text-white'}>
        {props.selectedUser?.email ? 'Update Existing User' : 'Create New User'}
      </ModalHeader>
      <ModalBody>
        <UserEditCreateForm
          userDetails={props.selectedUser}
          isEdit={props.selectedUser?.email}
          onSave={() => {
            props.setShowModal(false)
            props.getUserList(null, !props.showDeleted)
          }}
          roleList={props.roleList}
        />
      </ModalBody>
    </Modal>
  )
}

CreateUpdateUser.propTypes = {
  setShowModal: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
  selectedUser: PropTypes.object.isRequired,
  getUserList: PropTypes.func.isRequired,
  showDeleted: PropTypes.bool.isRequired,
  roleList: PropTypes.array,
}

export default CreateUpdateUser
